import React from 'react';
import styled from 'styled-components';

type Props = {
  title?: string;
  children: React.ReactNode;
  /** When true, content spans the full width rather than the centered card layout. */
  fullWidth?: boolean;
};

export const PageContainer = ({ title, children, fullWidth = false }: Props) => {
  return (
    <Outer>
      <Inner $fullWidth={fullWidth}>
        {title ? <Title>{title}</Title> : null}
        {children}
      </Inner>
    </Outer>
  );
};

const Outer = styled.div`
  display: flex;
  justify-content: center;
  padding: 50px 0 20px;
`;

const Inner = styled.div<{ $fullWidth: boolean }>`
  position: relative;
  background-color: #ffffff;
  padding: 25px;
  width: ${(props) => (props.$fullWidth ? 'calc(100% - 60px)' : 'clamp(600px, 75%, 1200px)')};
  margin: 0 auto;
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
  height: 100%;
`;

const Title = styled.h1`
  margin: 0 0 20px;
  padding: 0;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-size: 14pt;
  font-weight: 600;
  color: #333333;
`;
